import { render, staticRenderFns } from "./DoubleSideTriangleVertical.vue?vue&type=template&id=6fcd2904&scoped=true&"
import script from "./DoubleSideTriangleVertical.vue?vue&type=script&lang=js&"
export * from "./DoubleSideTriangleVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcd2904",
  null
  
)

export default component.exports